import { useContext } from 'react';

import { FormStepsContext } from '../context/FormStepsContext';

const useFormStepsContext = () => {
  const context = useContext(FormStepsContext);

  if (context === undefined) {
    throw new Error(
      'useFormStepsContext must be used within a FormStepsContextProvider (included on SecondVariationRoot)',
    );
  }

  return context;
};

export default useFormStepsContext;
